/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const WebCircledIcon = /*#__PURE__*/ createSvgIcon(
  'WebCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M6.25 8.567a.46.46 0 100-.919.46.46 0 000 .919zM8.37 8.107a.46.46 0 11-.92 0 .46.46 0 01.92 0zM9.57 8.567a.46.46 0 100-.919.46.46 0 000 .919z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.292 14.833c-.31 0-.574-.11-.795-.33-.22-.22-.33-.486-.33-.795V6.954c0-.31.11-.574.33-.792.22-.22.485-.329.795-.329h9.75c.31 0 .574.11.794.331.22.22.33.485.33.795v6.754c0 .31-.11.574-.33.792-.22.219-.485.328-.794.328h-9.75zm0-1.125h9.75v-3.36h-9.75v3.36zm0-4.486h9.75V6.958h-9.75v2.264z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default WebCircledIcon;
